const getCurrentEnvironment = () => {
  if (typeof window === "undefined") return undefined;

  if (window.atiEnv) return window.atiEnv.env;

  return "production";
};

export default getCurrentEnvironment;
